import React from 'react';
// import { CaseCoverageDiv } from './Details.styled';
import { AccountFieldTitle, LineSeparator, OptionContainer, OptionCoverageContainer, OuterContainer } from './mazorCaseCoverageTemplate.styled';
import { accountNumberZeroTrimmer } from 'src/utils/util';

export default function MazorCaseCoverageTemplate({ option, fieldname, value,  nameWidth }) {
    return (
        <>
            <OuterContainer display={'block'}>
                <div style={{ display: 'block' }}>
                    <>
                        <OptionContainer padding={'10px 10px 5px 10px'}>
                            <OptionCoverageContainer>
                                <AccountFieldTitle
                                    width={'100%'}
                                    mobileWidth={nameWidth ? nameWidth : '100%'}
                                    iPadwidth={nameWidth ? nameWidth : '100%'}
                                >
                                    {option?.caseCoverageName
                                        ? option?.caseCoverageName
                                        : ''}
                                </AccountFieldTitle>
                                <AccountFieldTitle
                                    margin="0px 5px"
                                    fontFamily="AvenirNextWorld Regular"
                                >
                                    <span className="report-usage-account-address-dt-mask">{fieldname === 'mazorCaseCoverage' ||
                                    'stealthAxisCaseCoverage'
                                        ? accountNumberZeroTrimmer(
                                              option.caseCoverageCustomerId ||
                                                  ''
                                          )
                                        : null}</span>
                                </AccountFieldTitle>
                            </OptionCoverageContainer>
                        </OptionContainer>
                    </>
                    <LineSeparator></LineSeparator>
                </div>
            </OuterContainer>
        </>
    );
}
